import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function UploadIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5496 4.23966C12.4077 4.08684 12.2086 4 12 4C11.7914 4 11.5923 4.08684 11.4504 4.23966L8.20041 7.73966C7.91855 8.04319 7.93613 8.51774 8.23966 8.7996C8.54319 9.08145 9.01774 9.06387 9.29959 8.76034L11.25 6.6599V14.25C11.25 14.6642 11.5858 15 12 15C12.4142 15 12.75 14.6642 12.75 14.25V6.6599L14.7004 8.76034C14.9823 9.06387 15.4568 9.08145 15.7603 8.7996C16.0639 8.51774 16.0814 8.04319 15.7996 7.73966L12.5496 4.23966Z"
        fill="currentColor"
      />
      <path
        d="M4.75 14C5.16421 14 5.5 14.3358 5.5 14.75V16.25C5.5 17.4927 6.50736 18.5 7.75 18.5H16.25C17.4927 18.5 18.5 17.4927 18.5 16.25V14.75C18.5 14.3358 18.8358 14 19.25 14C19.6642 14 20 14.3358 20 14.75V16.25C20 18.3211 18.3211 20 16.25 20H7.75C5.67894 20 4 18.3211 4 16.25V14.75C4 14.3358 4.33579 14 4.75 14Z"
        fill="currentColor"
      />
    </svg>
  );
};
